import { render, staticRenderFns } from "./Disbursements.vue?vue&type=template&id=38fc5af2&scoped=true"
import script from "./Disbursements.vue?vue&type=script&lang=js"
export * from "./Disbursements.vue?vue&type=script&lang=js"
import style0 from "./Disbursements.vue?vue&type=style&index=0&id=38fc5af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc5af2",
  null
  
)

export default component.exports